import { render, staticRenderFns } from "./DocumentToHtml.vue?vue&type=template&id=4b086ad6&scoped=true&"
import script from "./DocumentToHtml.vue?vue&type=script&lang=js&"
export * from "./DocumentToHtml.vue?vue&type=script&lang=js&"
import style0 from "./DocumentToHtml.vue?vue&type=style&index=0&id=4b086ad6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b086ad6",
  null
  
)

export default component.exports